import React, { Component } from "react";
import ModalContainer from "../../../../../modules/commons/ModalContainer";
import SimpleModal from "../../../../../modules/popup/SimpleModal";
import SimpleDataTable from "../../../../../modules/SimpleDataTable";
import Api from "../../../../../Services/Api";
import { fetchDataAsync } from "../../../../../Services/Utils";
import { HttpStatus } from "../../../../common/Constants";
import { INITIAL_PAGINATION } from "../../constant";
import { getTableConfigBKKBBK } from "../section/config";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";

class ModalBKKBBK extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pagination: INITIAL_PAGINATION,
      listBbk: [],
      listBkk: [],
    };
  }

  componentDidMount() {
    this.fetchDataBBM();
  }

  fetchDataBBM = async (value) => {
    const { setError, onTriggerLoading, selectedCabang } = this.props;

    onTriggerLoading();
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION").getListBKKBBKManagementClaim,
      menuName: "Management Claim",
      setError: setError,
      args: {
        kodeCabang: selectedCabang?.value,
      },
    });
    onTriggerLoading();
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState((prev) => ({
        ...prev,
        listBbk: res.data.data?.listBbk,
        listBkk: res.data.data?.listBkk,
      }));
    }
  };

  getTableConfig = (tab) => {
    const {setValue, onClickClose} = this.props;
    return getTableConfigBKKBBK({
      tab,
      onSelect: (name, value)=> {
        setValue(name, value)
        onClickClose()
      }
    });
  };

  render() {
    const { visible, onClickClose } = this.props;
    const { pagination, listBbk, listBkk } = this.state;
    return (
      <SimpleModal
        title="List Nomor Dokumen Payment "
        visible={visible}
        onClickClose={onClickClose}
        content={
          <React.Fragment>
            <ModalContainer>
              <Tabs>
                <TabList>
                  <Tab>Nomor BBK</Tab>
                  <Tab>Nomor BKK</Tab>
                </TabList>
                <TabPanel>
                  <SimpleDataTable
                    data={listBbk}
                    columns={this.getTableConfig("bbk")}
                    toCount={pagination.totalData}
                    rowsPerPage={pagination.limit}
                    page={pagination.page - 1}
                    options={{
                      serverSide: false,
                    }}
                  />
                </TabPanel>
                <TabPanel>
                  <SimpleDataTable
                    data={listBkk}
                    columns={this.getTableConfig("bkk")}
                    toCount={pagination.totalData}
                    rowsPerPage={pagination.limit}
                    page={pagination.page - 1}
                    options={{
                      serverSide: false,
                    }}
                  />
                </TabPanel>
              </Tabs>
            </ModalContainer>
          </React.Fragment>
        }
      />
    );
  }
}

export default ModalBKKBBK;
